import { ROUTES } from 'Constants';
import { store } from 'Models/Store';
import { NewModal } from 'Views/Components/Modal/NewModal';
import { buildRepriceHandoffUrl } from '../Types/repriceSelection';

function UpdateInvoicedBookingsPromptBody({ customerName, onUpdate, onDismiss }: {
	customerName: string;
	onUpdate: () => void;
	onDismiss: () => void;
}) {
	return (
		<>
			<NewModal.Header>
				<NewModal.Title>Update their existing bookings?</NewModal.Title>
			</NewModal.Header>
			<NewModal.Body>
				<p className="text-sm text-gray-600 pt-2">
					{customerName ? <strong>{customerName}</strong> : 'This customer'} is invoiced, and bookings
					they have already made keep the price they were booked at.
				</p>
				<p className="text-sm text-gray-600 pt-2">
					Review their unpaid invoiced bookings against the prices you just saved, and choose which to
					update.
				</p>
			</NewModal.Body>
			<NewModal.Footer>
				<NewModal.CancelButton onClick={onDismiss}>Not now</NewModal.CancelButton>
				<NewModal.ConfirmButton onClick={onUpdate}>Update bookings</NewModal.ConfirmButton>
			</NewModal.Footer>
		</>
	);
}

/**
 * Offered after a manager saves a change to an invoiced customer's own prices.
 *
 * A booking's fare is snapshotted when it is made, so a customer's new prices apply only to bookings they
 * make from now on — everything already booked stays on the old price until someone re-costs it. This is
 * the moment the operator knows that, so it is the moment to offer it. It is an offer, not a step: "Not
 * now" leaves the save exactly as it was.
 *
 * The link pre-fills THIS customer only and leaves the dates for the operator, the same as the other
 * handoffs into the wizard — which bookings should move is not something this screen can decide.
 */
export function showUpdateInvoicedBookingsPrompt(
	navigate: (url: string) => void,
	customer: { id: string; name: string },
) {
	store.modal.show(
		'Update their existing bookings?',
		<UpdateInvoicedBookingsPromptBody
			customerName={customer.name}
			onUpdate={() => {
				store.modal.hide();
				navigate(buildRepriceHandoffUrl(ROUTES.ADMIN.INVOICED_BOOKING_REPRICE.url(), { userIds: [customer.id] }));
			}}
			onDismiss={() => store.modal.hide()}
		/>,
		{ newModal: true, className: 'confirm-modal' },
	);
}
